module.exports = __webpack_public_path__ + "img/greenwich-g-series-top-angle.33387bd4.png";